import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Plus, X, User as UserIcon, Receipt, CurrencyDollar, Buildings, Truck } from "@phosphor-icons/react";

const ITEMS = [
  { label: "New Person", icon: UserIcon, action: (nav) => nav("/users?new=1") },
  { label: "New Vendor", icon: Truck, action: (nav) => nav("/masters?new=vendors") },
  { label: "New Client", icon: UserIcon, action: (nav) => nav("/masters?new=clients") },
  { label: "New Company / Firm", icon: Buildings, action: (nav) => nav("/masters?new=companies") },
  { label: "New Invoice", icon: Receipt, action: (nav) => nav("/business?new=invoice") },
  { label: "New Finance Entry", icon: CurrencyDollar, action: (nav) => nav("/finance?new=1") },
];

export default function FloatingCreate() {
  const [open, setOpen] = useState(false);
  const nav = useNavigate();

  return (
    <>
      <button
        data-testid="floating-create"
        onClick={() => setOpen(!open)}
        className="fixed bottom-6 right-6 z-40 w-14 h-14 rounded-full bg-neutral-900 text-white shadow-lg hover:bg-neutral-800 flex items-center justify-center transition-transform duration-200 hover:scale-105"
      >
        {open ? <X size={22} weight="bold" /> : <Plus size={22} weight="bold" />}
      </button>

      {open && (
        <>
          <div className="fixed inset-0 z-30" onClick={() => setOpen(false)} />
          <div className="fixed bottom-24 right-6 z-40 bg-white border border-neutral-200 rounded-lg shadow-xl w-64 py-2 fade-in">
            <div className="px-3 py-2 text-[10px] uppercase tracking-wider text-neutral-500 font-semibold">Quick Create</div>
            {ITEMS.map((it) => (
              <button
                key={it.label}
                data-testid={`create-${it.label.toLowerCase().replace(/[^a-z]+/g, "-")}`}
                onClick={() => { it.action(nav); setOpen(false); }}
                className="w-full flex items-center gap-2 px-3 py-2 text-sm text-neutral-800 hover:bg-neutral-50 text-left transition-colors duration-200"
              >
                <it.icon size={14} className="text-neutral-500" />
                {it.label}
              </button>
            ))}
          </div>
        </>
      )}
    </>
  );
}
